<template>
    <el-submenu
            :popper-append-to-body="false"
            v-if="menu.list && menu.list.length >= 1"
            :index="menu.id+''"
    >
        <template slot="title">
            <span>{{ menu.name }}</span>
        </template>
        <voc-sub-menu
                v-for="item in menu.list"
                :key="item.id+''"
                :menu="item"
        >
        </voc-sub-menu>
    </el-submenu>
    <el-menu-item v-else :index="menu.id+''" @click="gotoRouteHandle(menu)">


        <el-popover
                v-if="menu.apiRemark || menu.legendImage"
                placement="right"
                width="300"
                trigger="hover"
        >
            <div class="menuTips">
                <div class="menuTipsImg" v-if="menu.legendImage"><img :src="menu.legendImage" alt=""></div>
                <div class="menuTipsRemark" v-if="menu.apiRemark">{{menu.apiRemark}}</div>
            </div>
            <span slot="reference">{{ menu.name }}</span>
        </el-popover>

<!--        <el-tooltip class="item" effect="dark" :content="tooltipContent" placement="right">-->

<!--            <span>{{ menu.name }}</span>-->
<!--        </el-tooltip>-->
        <span v-else>{{ menu.name }}</span>
    </el-menu-item>
</template>

<script>
    import VocSubMenu from './main-sidebar-data-menu'

    export default {
        name: 'voc-sub-menu',
        data(){
            return {
                tooltipContent: `
        <div>
          <img src="https://via.placeholder.com/50" alt="example" style="width: 50px; height: 50px;"/>
          <p>This is an example tooltip content with an image and some text.</p>
        </div>
      `
            }
        },
        props: {
            menu: {
                type: Object,
                required: true
            },
        },
        computed: {
            dataAnalysedTagsList: {
                get() {
                    return this.$store.state.dataAnalysedTagsList
                },
                set(val) {
                    this.$store.commit("updatedataAnalysedTagsList", val);
                }
            },
        },
        components: {
            VocSubMenu
        },
        methods: {
            // 通过menuId与动态(菜单)路由进行匹配跳转至指定路由
            gotoRouteHandle(item) {
                let self = this

                if(!item.url){
                    return
                }

                self.handleVOCTagsList(item)
                self.$router.push({name: item.url,query:{id:item.id}})


            },
            handleVOCTagsList(item) {

                let List = JSON.parse(JSON.stringify(this.dataAnalysedTagsList)) || []
                // let List = this.VOCTagsList || []
                let isExist = false
                for (let i = 0; i < List.length; i++) {
                    if (List[i].url === item.url && List[i].id === item.id) {
                        isExist = true
                        break
                    }
                }

                if (!isExist) {
                    List.push(item)
                    this.dataAnalysedTagsList = List
                }

            },
        }
    }
</script>

<style lang="less">
    .menuTips{
        text-align: center;
        .menuTipsImg{
            img{
                width: 200px;
                height: 200px;
            }
        }
        .menuTipsRemark{
            font-size: 12px;
            margin-top: 10px;
            text-align: center;
        }
    }
</style>
